import { DeskConstants } from './DeskConstants';
import { deskSettingsSource, blipWebsocketHostName, messaginghubWebsocketHostName, blipWebsocketHostNameTenant, transcriptionSettingsSource, blipCopilotSettingsSource, portalDomain, blipDomainUrl, } from 'app.constants';
import { messaginghubWebsocketHostNameTenant } from 'app.constants';
import { AttendanceFeatures } from '../AttendanceFeatures';
export class DeskController {
    static $inject = ['$state', 'LoadingService', 'TranslateService', 'application', 'AccountService2', 'PermissionsService'];
    constructor($state, LoadingService, TranslateService, application, AccountService2, PermissionsService) {
        'ngInject';
        this.$state = $state;
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.AccountService2 = AccountService2;
        this.PermissionsService = PermissionsService;
        this.LoadingService.startLoading();
        const setProps = async () => {
            this.canEditDesk = await this.PermissionsService.hasPermissions(DeskConstants.WRITE, DeskConstants.DESK);
            const account = await this.AccountService2.me();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = this.application.shortName;
            this.webSocketParams = {
                messaginghubWebsocketHostNameTenant,
                messaginghubWebsocketHostName,
                blipWebsocketHostName,
                blipWebsocketHostNameTenant,
            };
            this.LoadingService.stopLoading();
            this.settingsSource = deskSettingsSource;
            this.transcriptionMfeSettingsSource = transcriptionSettingsSource;
            this.blipCopilotSettingsSource = blipCopilotSettingsSource;
            this.blipDomainUrl = blipDomainUrl;
            this.portalDomain = portalDomain;
            this.user = account.identity;
            this.width = this.$state.current.data.width;
        };
        setProps();
    }
    async $onInit() {
        await this.checkFeatures();
    }
    async checkFeatures() {
        this.deskGranularityHasEnabled = await AttendanceFeatures.isAttendancePermissionsGranularityEnabled().then((enabled) => {
            if (enabled) {
                this.deskPermissions = this.PermissionsService.getDeskPermissions();
            }
            return enabled;
        });
    }
}
DeskController.$inject = ['$state', 'LoadingService', 'TranslateService', 'application', 'AccountService2', 'PermissionsService'];
